const state = function () {
  return {
    loadingData: false,
    list: [],
    currentManagerId: null,
    refresh: false,
    uploadModal: {
      open: false
    },
    uploadForm: {
      DOCUMENT_ID: null,
      LK_DOCUMENT_TYPE_ID: null,
      LK_ENTITY_ID: null,
      ENTITY_ITEM_ID: null,
      DOCUMENT_NAME: ''
    },
    documentForm: {
      DOCUMENT_ID: null,
      USER_ID: null,
      LK_FILE_TYPE_ID: null,
      LK_DOCUMENT_TYPE_ID: null,
      DOCUMENT_NAME: ''
    },
    readingRoster: false,
  }
}

export default {
  ...state()
}

export const initialState = state()
